import { actions as loadingActions } from "../../components/loading/index";
import {history} from '../../extendedBrowserRouter'
import {
  notification
} from "antd";

export const loadCPLeaderBoard = () => {
  return (dispatch, getState, { getFirestore, getFirebase }) => {
    const firestore = getFirestore();
    dispatch(loadingActions.showLoading());
    firestore
      .collection("CPLeaderBoard").doc("Dashboard")
      .get()
      .then(doc => {
        dispatch({
          type: "LOAD_CP_LEADERBOARD",
          payload: doc.exists
            ? {
                valid: true,
                data: {...doc.data()},
              }
            : { valid: false, data:[] }
        });
        dispatch(loadingActions.hideLoading());
      })
      .catch(function(error) {
        
        dispatch(loadingActions.hideLoading());
        notification.error({
          message: 'Something went wrong',
          description:
            'please report to the admin@vedic.dev'+error
        });
      });
  };
};
